import { FC, HTMLAttributes } from 'react'

interface PhoneIconProps extends HTMLAttributes<HTMLElement> {
  className?: string
  height?: number
  width?: number
}

export const PhoneIcon: FC<PhoneIconProps> = ({ className, height, width }) => (
  <svg
    width={width || 27}
    height={height || 28}
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M25.4993 20.466V24.38C25.5006 24.7434 25.4318 25.1031 25.2971 25.436C25.1625 25.7689 24.965 26.0678 24.7174 26.3134C24.4698 26.559 24.1774 26.7461 23.859 26.8625C23.5407 26.9789 23.2033 27.0221 22.8686 26.9894C19.1554 26.5532 15.5885 25.1813 12.4547 22.984C9.53906 20.9809 7.06712 18.3083 5.2144 15.1559C3.17503 11.7523 1.90589 7.8771 1.50979 3.84433C1.47964 3.48355 1.5193 3.11992 1.62624 2.77661C1.73319 2.43331 1.90508 2.11783 2.13097 1.85029C2.35686 1.58274 2.6318 1.36897 2.93829 1.2226C3.24478 1.07623 3.5761 1.00047 3.91115 1.00013H7.53129C8.11692 0.993895 8.68466 1.21811 9.12869 1.63098C9.57273 2.04386 9.86276 2.61721 9.94472 3.24418C10.0975 4.49676 10.3809 5.72664 10.7894 6.91034C10.9518 7.37732 10.9869 7.88483 10.8907 8.37273C10.7944 8.86064 10.5708 9.30849 10.2464 9.66322V9.66322C9.32786 10.6563 9.11497 12.1349 9.86861 13.2583C11.0506 15.0203 12.4803 16.5715 14.1055 17.8557C15.1347 18.6689 16.596 18.4543 17.4867 17.4913V17.4913C17.8148 17.1405 18.229 16.8988 18.6803 16.7947C19.1315 16.6907 19.6009 16.7287 20.0328 16.9042C21.1277 17.3459 22.2652 17.6523 23.4237 17.8175C24.0099 17.9069 24.5452 18.2261 24.9279 18.7145C25.3106 19.2028 25.5139 19.8261 25.4993 20.466Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
